// Incidents
const incidents = "incidents/";
const closedIncidents = "incidents/closed/";
const customerIncidents = `incidents/customer/`;
const createIncident = "create/incident/";

// Changes
const changes = "changes/";
const closedChanges = "changes/closed/";
const changeActivities = "changes/activities/";
const createChange = "create/change/";
const standardChanges = "changes/standard/";
const nonStandardChanges = "changes/nonStandard/";
const customerChanges = "changes/customer/";

// Invoices
const invoicePeriods = "invoices/periods/";
const invoices = "invoices/";

// Licences
const licences = "licenses/";
const customerLicences = "licenses/customer/";

// Employees
const employeeTime = "employee/time/";

// Devices
const alerts = "alerts/";
const devices = "devices/";
const workstations = "workstations/";
const servers = "servers/";
const serversOffline = "servers/offline/";
const healthStatus = "healthstatus/";
const companyDevices = "devices/company/";

// Customers
const createProjects = `create/customer/projects/`;
const createTopDeskCustomer = "create/customers/topdesk/";
const dashboardCustomers = "customers/openprojects/";
const customerexiststopdesk = "customers/exists/topdesk/";
const customerexiststimechimp = "customers/exists/timechimp/";
const customerexistsarrow = "customers/exists/arrow/";
const customerexistspax8 = "customers/exists/pax8/";

// Projects
const projects = "projects/";
const changeMethod = "projects/paymentmethod";
const customerProjects = "projects/customers";
const archiveProject = "projects/archivestatus";
const projectDetails = "projects/details";

// -------------------------------------------

// Customers page
const customersList = "customers/";
const timechimpCustomers = "customer/timechimp/";
const customersExistList = "customers/exists/"

export {
  incidents,
  employeeTime,
  licences,
  invoices,
  dashboardCustomers,
  changes,
  timechimpCustomers,
  createProjects,
  changeActivities,
  customerChanges,
  customerIncidents,
  customerLicences,
  customersList,
  createChange,
  invoicePeriods,
  standardChanges,
  nonStandardChanges,
  alerts,
  devices,
  workstations,
  servers,
  serversOffline,
  healthStatus,
  companyDevices,
  createTopDeskCustomer,
  closedChanges,
  closedIncidents,
  projects,
  changeMethod,
  customerProjects,
  archiveProject,
  createIncident,
  projectDetails,
  customersExistList,
  customerexistsarrow,
  customerexistspax8,
  customerexiststimechimp,
  customerexiststopdesk
};
